import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['d-flex', 'item', 'horizontal'])
}
const _hoisted_2 = { class: "item-icon" }
const _hoisted_3 = { class: "item-text filler" }
const _hoisted_4 = { class: "item-title" }
const _hoisted_5 = {
  key: 0,
  class: "sub-title text-muted font-size-small"
}
const _hoisted_6 = {
  key: 0,
  class: "chevron text-muted"
}

import {computed} from 'vue';
import ISideMenuItem from "~/chat/vue/widget/sideMenu/ISideMenuItem";
import ChatSelectableItem from "~/chat/vue/misc/ChatSelectableItem.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import SvgIconBackgroundWrapper from "~/chat/vue/misc/SvgIconBackgroundWrapper.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import TriggerMenuItem from "~/chat/vue/trigger/menu/TriggerMenuItem.vue";
import TriggerUnreadedCount from "~/chat/vue/trigger/TriggerUnreadedCount.vue";
import {TRIGGER_MENU_ITEM_TYPE_CHAT} from "~/chat/ts/data/ISiteParams";


const __default__ = {
    name: "SideMenuItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: {}
  },
  setup(__props: any) {

let props = __props

let items = computed(() => {
    let result: ISideMenuItem[] = [];
    result.push(props.item);
    if (props.item.children) {
        result.push(...props.item.children);
    }
    return result;
});

let menuItemComponent = computed(() => {
    return TriggerMenuItem;
});

function onClick(item: ISideMenuItem) {
    if (!item.originalMenuItem) {
        item.onClick();
    }
}

let needToShowUnreadedCount = computed(() => {
    if (props.item.originalMenuItem) {
        return props.item.originalMenuItem.type == TRIGGER_MENU_ITEM_TYPE_CHAT;
    } else {
        return false;
    }
});

let className = computed(() => {
    return {
        root: true,
        desktop: !ConfigStore.isMobile.value
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(className))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(item.originalMenuItem ? _unref(menuItemComponent) : 'div'), {
        key: index,
        item: item.originalMenuItem
      }, {
        default: _withCtx(() => [
          _createVNode(ChatSelectableItem, {
            class: _normalizeClass(['selectable-item', 'filler', index ? 'sub' : 'main']),
            onClick: ($event: any) => (onClick(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(SvgIconBackgroundWrapper, {
                    class: "icon",
                    style: _normalizeStyle({
                                [index ? 'color' : 'background']: `${item.iconColor} !important`
                            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        "icon-name": item.icon,
                        "icon-style": item.iconStyle? item.iconStyle : 'light'
                      }, null, 8, ["icon-name", "icon-style"])
                    ]),
                    _: 2
                  }, 1032, ["style"]),
                  (_unref(needToShowUnreadedCount))
                    ? (_openBlock(), _createBlock(TriggerUnreadedCount, {
                        key: 0,
                        class: "unreaded-count"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
                  (item.subTitle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.subTitle), 1))
                    : _createCommentVNode("", true)
                ]),
                (_unref(items).length === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(SvgIcon, {
                        "icon-name": "header-back",
                        "icon-style": "light"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["class", "onClick"])
        ]),
        _: 2
      }, 1032, ["item"]))
    }), 128))
  ], 2))
}
}

})